import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/footer/ftlink3.png")